import { createClient, SupabaseClient } from '@supabase/supabase-js';

declare global {
  interface Window {
    __ALSHIRAA_PORTAL_CONFIG__?: {
      supabaseUrl?: string;
      supabaseAnonKey?: string;
    };
  }
}

const readConfig = () => {
  const runtime =
    typeof window !== 'undefined' ? window.__ALSHIRAA_PORTAL_CONFIG__ : undefined;
  return {
    url: process.env.SUPABASE_URL || runtime?.supabaseUrl || '',
    key: process.env.SUPABASE_ANON_KEY || runtime?.supabaseAnonKey || '',
  };
};

export const isSupabaseConfigured = () => {
  const { url, key } = readConfig();
  return Boolean(url && key && url.startsWith('https://'));
};

let client: SupabaseClient | null = null;

export const getSupabase = (): SupabaseClient | null => {
  if (!isSupabaseConfigured()) return null;

  const { url, key } = readConfig();
  if (!client) {
    client = createClient(url, key, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    });
  }
  return client;
};

export interface DbProfile {
  id: string;
  email: string;
  name: string;
  role: 'client' | 'admin';
  company: string | null;
  client_code?: string | null;
}

export interface DbShipment {
  id: string;
  declaration_number: string;
  client_email: string;
  client_name: string;
  company: string | null;
  client_code?: string | null;
  client_phone?: string | null;
  cargo_description: string;
  border: string;
  weight_tons: number | null;
  status: string;
  updated_at: string;
  created_at: string;
}

export interface DbHistoryRow {
  id: string;
  shipment_id: string;
  status: string;
  note: string | null;
  created_at: string;
}
